/**
 * Route for `public-usage-calculator`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublicUsageCalculatorPage } from "../features/public-usage-calculator/PublicUsageCalculatorPage";

export const publicUsageCalculatorRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/public-usage-calculator",
	component: PublicUsageCalculatorPage,
});

export default publicUsageCalculatorRoute;
